/**
 * Shared types for the program flows. The response shapes mirror what the
 * backend returns at /dashboard/programs and /dashboard/products.
 */

export type FundingMode = 'prefunded' | 'delegated';

export const FUNDING_MODES: FundingMode[] = ['prefunded', 'delegated'];

export const FUNDING_MODE_COPY: Record<
  FundingMode,
  { label: string; summary: string; detail: string }
> = {
  prefunded: {
    label: 'Prefunded',
    summary: 'Authorize against each cardholder balance',
    detail:
      'Seven holds a float per cardholder and auto-declines when it runs out. Simplest to operate; good for payouts, salary, benefits.',
  },
  delegated: {
    label: 'Delegated',
    summary: 'Route every authorization to your service',
    detail:
      "Seven calls your customer auth webhook on every authorization and takes your decision. You own the balance ledger and the limits. Requires a URL that responds within ~1 s.",
  },
};

export interface Product {
  id: string;
  name: string;
  providerProfileName: string;
  network: string;
  currency: string;
  category: string;
  isActive: boolean;
}

export interface Program {
  id: string;
  tenantId: string;
  displayName: string;
  fundingMode: FundingMode;
  accountId: string | null;
  product: Product;
  customerWebhookUrl: string | null;
  createdAt: string;
}
